var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglasscircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1358_1690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 19.9219C15.4102 19.9219 19.9219 15.4004 19.9219 9.96094C19.9219 4.51172 15.4004 0 9.95117 0C4.51172 0 0 4.51172 0 9.96094C0 15.4004 4.52148 19.9219 9.96094 19.9219ZM9.96094 18.2617C5.35156 18.2617 1.66992 14.5703 1.66992 9.96094C1.66992 5.35156 5.3418 1.66016 9.95117 1.66016C14.5605 1.66016 18.2617 5.35156 18.2617 9.96094C18.2617 14.5703 14.5703 18.2617 9.96094 18.2617Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 15.6641H12.5879C13.2129 15.6641 13.5938 15.3027 13.5938 14.6484V14.5215C13.5938 13.0273 12.0117 11.4355 11.1426 10.5664C10.7129 10.1465 10.7422 9.7168 11.1426 9.33594C12.0117 8.47656 13.5938 6.88477 13.5938 5.38086V5.27344C13.5938 4.60938 13.2129 4.24805 12.5879 4.24805H7.33398C6.70898 4.24805 6.32812 4.60938 6.32812 5.27344V5.38086C6.32812 6.88477 7.91016 8.47656 8.7793 9.33594C9.17969 9.7168 9.20898 10.1465 8.7793 10.5664C7.91016 11.4355 6.32812 13.0273 6.32812 14.5215V14.6484C6.32812 15.3027 6.70898 15.6641 7.33398 15.6641ZM7.8125 14.8242C7.53906 14.8242 7.49023 14.5117 7.66602 14.3457L9.52148 12.4512C9.58984 12.3828 9.61914 12.3535 9.61914 12.2559V9.51172C9.61914 9.23828 9.56055 9.10156 9.36523 8.91602C8.93555 8.48633 8.48633 8.04688 8.10547 7.63672C7.92969 7.4707 8.02734 7.28516 8.22266 7.28516H11.709C11.9043 7.28516 11.9922 7.4707 11.8262 7.63672C11.4355 8.04688 10.9863 8.48633 10.5566 8.91602C10.3613 9.10156 10.3027 9.23828 10.3027 9.51172V12.2559C10.3027 12.3535 10.332 12.3828 10.4004 12.4512L12.2559 14.3457C12.4316 14.5117 12.3828 14.8242 12.1094 14.8242H7.8125Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1358_1690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2832,
    height: 19.9316,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglasscircle);
export default __webpack_public_path__ + "static/media/hourglass.circle.fdb61ae00b717e4993d6828713ba589f.svg";
export { ForwardRef as ReactComponent };